define(['./module'], function(MODULE_NAME) {
    return MODULE_NAME;
});



//////////////////
// WEBPACK FOOTER
// ./main.js
// module id = 0
// module chunks = 0